module.exports = __webpack_public_path__ + "63509960b66394c975b692d87534d1d4.svg";